/*
 * TerriSTORY®
 *
 © Copyright 2022 AURA-EE
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * A copy of the GNU Affero General Public License should be present along
 * with this program at the root of current repository. If not, see
 * http://www.gnu.org/licenses/.
 */

import React, { useState } from "react";
import FadeInSection from "../Utils/FadeInSection";
import "../../style/homepage.css";

/**
 * This component is used to manage the 'Modules' page of the application
 */
function Modules() {
  const [isNational, setNational] = useState(false);
  const nationalClass = isNational ? " not-national" : "";
  const returnTop = /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0", /*#__PURE__*/React.createElement("a", {
    href: "#root",
    className: "return-top"
  }, "\u2191"));
  return /*#__PURE__*/React.createElement("div", {
    className: "widgets full-screen-widget"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tout about"
  }, /*#__PURE__*/React.createElement("div", {
    className: "img larger-logo"
  }, /*#__PURE__*/React.createElement("img", {
    src: "../../img/logo_TerriSTORY_transparent.png",
    alt: "Logo de TerriSTORY\xAE"
  })), /*#__PURE__*/React.createElement("div", {
    className: "texte-corps"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "whole-width"
  }, /*#__PURE__*/React.createElement(FadeInSection, null, /*#__PURE__*/React.createElement("h1", null, "L'outil"))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FadeInSection, null, /*#__PURE__*/React.createElement("h2", null, "Vue d'ensemble"), /*#__PURE__*/React.createElement("p", null, "TerriSTORY\xAE a pour but de remplir les objectifs suivants :"), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement("li", null, "comprendre son territoire, r\xE9aliser un", " ", /*#__PURE__*/React.createElement("span", {
    className: "color1"
  }, /*#__PURE__*/React.createElement("strong", null, "diagnostic multi-th\xE9matique")), " ", "\xE0 partir de donn\xE9es de qualit\xE9"), /*#__PURE__*/React.createElement("li", null, "analyser les dynamiques \xE0 l'oeuvre sur territoire et les", " ", /*#__PURE__*/React.createElement("span", {
    className: "color2"
  }, /*#__PURE__*/React.createElement("strong", null, "trajectoires historiques")), " ", "des principaux indicateurs autour du climat et de l'\xE9nergie"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement("span", {
    className: "color3"
  }, "simuler des sc\xE9narios prospectifs")), " ", "et d'en mesurer les impacts socio-\xE9conomiques et environnementaux, pour", " ", /*#__PURE__*/React.createElement("strong", null, "construire une trajectoire territoriale"), " ", "\xE0 la hauteur des enjeux et des objectifs.")))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FadeInSection, null, /*#__PURE__*/React.createElement("img", {
    alt: "D\xE9couvrez une interface : Interactive, Intuitive, \xC9volutive",
    title: "Les avantages de l'interface de TerriSTORY",
    src: "/img/national/interface.jpg",
    className: "map"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "whole-width"
  }, /*#__PURE__*/React.createElement(FadeInSection, null, /*#__PURE__*/React.createElement("h2", null, "Les modules"), /*#__PURE__*/React.createElement("p", null, "Pour cela, l'outil est s\xE9par\xE9 en", " ", /*#__PURE__*/React.createElement("strong", null, "cinq modules principaux"), " d\xE9crits ci-dessous. Ces modules sont d\xE9ploy\xE9s dans chaque r\xE9gion par l'\xE9quipe de d\xE9veloppement de TerriSTORY\xAE puis aliment\xE9s et personnalis\xE9s par les", " ", /*#__PURE__*/React.createElement("strong", null, "administrateurs r\xE9gionaux de TerriSTORY\xAE"), ". Ceux-ci choisissent entre autres les donn\xE9es et indicateurs qui figurent dans l'outil. Cela peut expliquer des diff\xE9rences de fonctionnalit\xE9s et de contenus d'une r\xE9gion \xE0 l'autre."), /*#__PURE__*/React.createElement("div", {
    className: "list-modules"
  }, /*#__PURE__*/React.createElement("div", {
    className: nationalClass
  }, /*#__PURE__*/React.createElement("img", {
    src: "/img/national/icon_indicateur.svg",
    alt: "indicateur"
  }), /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("a", {
    href: "#module-indicateur"
  }, "indicateurs"))), /*#__PURE__*/React.createElement("div", {
    className: nationalClass
  }, /*#__PURE__*/React.createElement("img", {
    src: "/img/national/icon_installation.svg",
    alt: "installation"
  }), /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("a", {
    href: "#module-installation"
  }, "\xE9quipements"))), /*#__PURE__*/React.createElement("div", {
    className: nationalClass
  }, /*#__PURE__*/React.createElement("img", {
    src: "/img/national/icon_dashboard.svg",
    alt: "dashboard"
  }), /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("a", {
    href: "#module-dashboard"
  }, "tableaux de bord"))), /*#__PURE__*/React.createElement("div", {
    className: nationalClass
  }, /*#__PURE__*/React.createElement("img", {
    src: "/img/national/icon_analyse.svg",
    alt: "analyse"
  }), /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("a", {
    href: "#module-analyse"
  }, "analyse"))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: "/img/national/icon_plan_action.svg",
    alt: "plan_action"
  }), /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("a", {
    href: "#module-plan_action"
  }, "simulateurs et strat\xE9gie territoriale")))))), /*#__PURE__*/React.createElement("div", {
    className: "whole-width"
  }, /*#__PURE__*/React.createElement(FadeInSection, null, /*#__PURE__*/React.createElement("h2", null, "Une version nationale"), /*#__PURE__*/React.createElement("p", null, "Depuis septembre 2024, certains des modules suivants sont d\xE9ploy\xE9s pour n'importe quelle r\xE9gion de France m\xE9tropolitaine, y compris les r\xE9gions non membres du consortium TerriSTORY\xAE. Pour visualiser quels sont les indicateurs pr\xE9sents, vous pouvez cliquer sur le bouton ci-dessous :"), /*#__PURE__*/React.createElement("div", {
    className: "category-switch"
  }, /*#__PURE__*/React.createElement("label", {
    key: "before",
    className: "switch-labels",
    htmlFor: "national-version-switch-button"
  }, "Territoire d'une r\xE9gion membre"), /*#__PURE__*/React.createElement("label", {
    key: "button",
    className: "switch"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    id: "national-version-switch-button",
    name: "national-version-switch-button",
    onChange: () => setNational(!isNational)
  }), /*#__PURE__*/React.createElement("span", {
    className: "slider round"
  })), /*#__PURE__*/React.createElement("label", {
    key: "after",
    htmlFor: "national-version-switch-button",
    className: "switch-labels"
  }, "Territoire hors consortium"))))), /*#__PURE__*/React.createElement("div", {
    className: "text-block" + nationalClass,
    id: "module-indicateur"
  }, /*#__PURE__*/React.createElement("div", {
    className: "whole-width"
  }, /*#__PURE__*/React.createElement(FadeInSection, null, /*#__PURE__*/React.createElement("h1", null, "Le module d'indicateurs", returnTop))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FadeInSection, null, /*#__PURE__*/React.createElement("img", {
    alt: "carte",
    src: "/img/national/carte.png",
    title: "Exemple de cartographie d'indicateurs en r\xE9gion Auvergne-Rh\xF4ne-Alpes",
    className: "map"
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FadeInSection, null, /*#__PURE__*/React.createElement("p", null, "Ce module est le", " ", /*#__PURE__*/React.createElement("strong", null, "point d'entr\xE9e de TerriSTORY\xAE"), " et permet la visualisation d'indicateurs sur une repr\xE9sentation cartographique. Des diagrammes en bas de page donnent acc\xE8s aux d\xE9tails sur certaines donn\xE9es.")))), /*#__PURE__*/React.createElement("div", {
    className: "text-block" + nationalClass,
    id: "module-installation"
  }, /*#__PURE__*/React.createElement("div", {
    className: "whole-width"
  }, /*#__PURE__*/React.createElement(FadeInSection, null, /*#__PURE__*/React.createElement("h1", null, "Le module d'\xE9quipements", returnTop))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FadeInSection, null, /*#__PURE__*/React.createElement("p", null, "L'affichage de points d'int\xE9r\xEAts (installations de production d'\xE9nergie, de traitement des d\xE9chets, r\xE9seaux de chaleur, projets marquants, etc.) enrichit la carte avec des informations g\xE9olocalis\xE9es."))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FadeInSection, null, /*#__PURE__*/React.createElement("img", {
    alt: "carte",
    src: "/img/national/carte_poi.png",
    title: "Exemple de carte d'\xE9quipements en r\xE9gion Bretagne",
    className: "map"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "text-block" + nationalClass,
    id: "module-dashboard"
  }, /*#__PURE__*/React.createElement("div", {
    className: "whole-width"
  }, /*#__PURE__*/React.createElement(FadeInSection, null, /*#__PURE__*/React.createElement("h1", null, "Le module de tableaux de bord", returnTop))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FadeInSection, null, /*#__PURE__*/React.createElement("img", {
    alt: "carte",
    src: "/img/national/tableaux_bord.png",
    title: "Exemple de tableaux de bord en r\xE9gion Nouvelle-Aquitaine",
    className: "map"
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FadeInSection, null, /*#__PURE__*/React.createElement("p", null, "Les tableaux de bord rassemblent une seule et m\xEAme page un grand nombre d'indicateurs et de repr\xE9sentations qui fournissent un aper\xE7u transverse ou encore une analyse pr\xE9cise sur une th\xE9matique au visiteur. Il est possible \xE0 un utilisateur connect\xE9 de se cr\xE9er ses propres tableaux de bord en s\xE9lectionnant les indicateurs souhait\xE9s.")))), /*#__PURE__*/React.createElement("div", {
    className: "text-block" + nationalClass,
    id: "module-analyse"
  }, /*#__PURE__*/React.createElement("div", {
    className: "whole-width"
  }, /*#__PURE__*/React.createElement(FadeInSection, null, /*#__PURE__*/React.createElement("h1", null, "Les modules d'analyse", returnTop))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FadeInSection, null, /*#__PURE__*/React.createElement("p", null, "Plusieurs outils diff\xE9rents permettent d'analyser dans le d\xE9tail les", " ", /*#__PURE__*/React.createElement("strong", null, "trajectoires historiques"), " des principaux indicateurs climat-air-\xE9nergie ou encore les diagrammes de flux \xE9nerg\xE9tiques des territoires."))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FadeInSection, null, /*#__PURE__*/React.createElement("img", {
    alt: "carte",
    src: "/img/national/suiv_traj.png",
    title: "Exemple de suivi de trajectoire en r\xE9gion Occitanie",
    className: "map"
  }), /*#__PURE__*/React.createElement("img", {
    alt: "carte",
    src: "/img/national/sankey.png",
    title: "Exemple de diagramme Sankey en r\xE9gion Occitanie",
    className: "map"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "text-block",
    id: "module-plan_action"
  }, /*#__PURE__*/React.createElement("div", {
    className: "whole-width"
  }, /*#__PURE__*/React.createElement(FadeInSection, null, /*#__PURE__*/React.createElement("h1", null, "Les modules de simulation et de strat\xE9gie", returnTop))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FadeInSection, null, /*#__PURE__*/React.createElement("img", {
    alt: "carte",
    src: "/img/national/strategie.png",
    title: "Exemple de trajectoire calcul\xE9e en r\xE9gion Auvergne-Rh\xF4ne-Alpes",
    className: "map"
  }), /*#__PURE__*/React.createElement("img", {
    alt: "carte",
    src: "/img/national/simulateur.png",
    title: "Exemple du simulateur mobilit\xE9 en r\xE9gion Pays de la Loire",
    className: "map"
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FadeInSection, null, /*#__PURE__*/React.createElement("p", null, "Modules les plus complexes de TerriSTORY\xAE, le simulateur et le module de strat\xE9gie territoriale fournissent une capacit\xE9 de", " ", /*#__PURE__*/React.createElement("strong", null, "simuler la mise en place d'actions"), ". Apr\xE8s avoir d\xE9fini une trajectoire, \xE9labor\xE9 un plan d'action, l'utilisateur peut alors en mesurer les impacts socio-\xE9conomiques et environnementaux.")))))));
}
export default Modules;